import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=35cd4c9c&scoped=true&"
import script from "./Paginate.vue?vue&type=script&lang=js&"
export * from "./Paginate.vue?vue&type=script&lang=js&"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=35cd4c9c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cd4c9c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35cd4c9c')) {
      api.createRecord('35cd4c9c', component.options)
    } else {
      api.reload('35cd4c9c', component.options)
    }
    module.hot.accept("./Paginate.vue?vue&type=template&id=35cd4c9c&scoped=true&", function () {
      api.rerender('35cd4c9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-29WWMpi3zCEAy/JS/comp/Paginate.vue"
export default component.exports